import { rem } from '@nowsta/ux-common-components';
import styled from 'styled-components';

export const Form = styled.form`
  margin-top: ${rem(24)};
`;
